import React from 'react';
import { Link } from 'react-router-dom';
import './Logo.css';

const Logo = ({ linkTo = '/', className = '' }) => {
  return (
    <div className={`logo-container ${className}`}>
      <Link to={linkTo} className="logo-link">
        <img
          src="/assets/logo.png"
          alt="YourPlat4orm"
          className="logo-image"
        />
      </Link>
    </div>
  );
};

export default Logo;
